import gql from 'graphql-tag';

export const CMS_MUTATION_LINK_SPECIAL_OFFER = gql`
  mutation CMS_LinkSpecialOffer($input: linkSpecialOfferInput) {
    linkSpecialOffer(input: $input) {
      specialOffer {
        id
      }
    }
  }
`;
